if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.productCard = this.closest('product-card');
      this.cartItems = document.querySelector('cart-items');
      this.form = this.querySelector('form') || this.querySelector('[data-form]') || this;
      this.multiple = 'multiple' in this.dataset;
      this.multipleForms = 'multipleForms' in this.dataset;
      this.edit = 'edit' in this.dataset;
      this.scrollElement = this.form?.closest('.js-dropdn-content-scroll');

      if (this.multipleForms) {
        this.querySelector('[data-submit-multiple-forms]').addEventListener('click', this.onSubmitHandler.bind(this))
      } else {
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.querySelector('[data-errorclose]')?.addEventListener('click', this.onClosePopupError.bind(this));

      this.setCheckboxEvents();

      if (this.edit) {
        this.form.addEventListener('change', this.onFormChangeHandler.bind(this));
        this.form.addEventListener('input', this.onFormChangeHandler.bind(this));
      }

      !this.multipleForms && (this.backupFormData = new FormData(this.form));

      if (this.closest('cart-form-element') || this.closest('wishlist-items') && this.closest('.minicart-prd')) {
        moveQuantityNode(this);

        window.addEventListener('resize', debounce(() => {
          moveQuantityNode(this)
        }, 300))
      }
    }

    setCheckboxEvents() {
      if (this.multiple) {
        this.querySelectorAll('[type=checkbox]').forEach(item => item.addEventListener('change', this.onCheckboxCheck.bind(this)));
      }
    }

    afterRenderEvents(e) {
      this.setCheckboxEvents();
      this.onCheckboxCheck(e);
    }

    onFormChangeHandler() {
      this.querySelector('minicart-line-item[data-has-edit-action]').onFormChangeHandler();
    }

    onCheckboxCheck(e) {
      const toggleName = 'toggle_select';
      const toggleSelector = `[name=${toggleName}]`;
      const toggleElement = this.querySelector(toggleSelector);
      const checkboxElements = this.querySelectorAll('[type=checkbox]');
      const updateButton = () => {
        const checkedSize = Array.from(checkboxElements).filter(item => item.name !== toggleName && item.checked).length;
        const checkboxesSize = Array.from(checkboxElements).filter(item => item.name !== toggleName).length;
        const buttonElement = this.querySelector('[type=submit]');
        const buttonTextElement = buttonElement.querySelector('span');
        buttonTextElement.innerHTML = checkedSize ? `${window.variantStrings.addSelectedToCart}`.replace('[count]', String(checkedSize)).replace('[products]', checkedSize === 1 ? window.themeStrings.productCountOne : window.themeStrings.productCountOther) : checkboxesSize === 1 ? window.variantStrings.addToCart : window.variantStrings.addSelectAll;
        buttonElement.dataset.selectAll = String(!checkedSize);
      };
      const toggleCheck = () => {
        if (e && e.target.name === toggleName) {
          checkboxElements.forEach(item => item.checked = e.target.checked);
        } else {
          if (e && e.target.checked === false) {
            toggleElement.checked = false
          } else {
            if (Array.from(checkboxElements).every(item => {
              if (item.name !== toggleName) {
                return item.checked === true
              }
              return true
            })) {
              toggleElement.checked = true;
            }
          }
        }
      };
      const toggleSelectAllElement = () => {
        toggleElement.labels.forEach(item => item.textContent = item.dataset.textWhenChecked);
      };

      toggleCheck();
      updateButton();
    }

    selectAll() {
      const checkboxElements = this.querySelectorAll('[type=checkbox]');
      checkboxElements.forEach(item => item.checked = true);
    }

    onClosePopupError() {
      this.querySelector('.product-form__error-message-wrapper').hidden = true;
    }

    onSubmitHandler(evt) {
      evt && evt.preventDefault();
      let submitButton;

      if (this.multipleForms) {
        submitButton = this.querySelector('[data-submit-multiple-forms]');
      } else {
        submitButton = this.querySelector('[type="submit"]') || this.querySelector('[data-action="add"]');
      }
      if (submitButton.classList.contains('loading-process')) return;

      if (this.multiple && 'selectAll' in submitButton.dataset && submitButton.dataset.selectAll === 'true') {
        this.selectAll();
      }

      this.productCard?.disableHover();

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading-process');
      this.form.classList.add('loading-process');
      submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if ('onlyAnimation' in this.dataset) this.form.submit();

      let config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let formData;

      if (!this.multipleForms) {
        formData = new FormData(this.form);

        // if (!isMobile && form.getAll('quantity').length === 2) {
        //   delete второй
        // }
      }



      const sections = this.cartItems
        ? Array.from(new Set(this.cartItems.getSectionsToRender().filter(item => Boolean(document.querySelector('#' + item.id))).map(section => section.section))).filter(element => element !== undefined).slice(0, 5)
        : [];
      const sections_url = window.location.pathname;

      let cartItemsCountOld = this.cartItems ? this.cartItems.querySelectorAll('.minicart-prd').length : 0;
      const visibleCartQuantityOld = getVisibleCartQuantity.call(this);

      const getConnected = async () => {
        if (this.edit) {
          let actions = {
            add: {
              url: routes.cart_add_url,
              config: function () {
                formData.append('sections', sections);
                formData.append('sections_url', sections_url);
                config.body = formData;
                return config;
              }
            },
            remove: {
              url: routes.cart_change_url,
              config:
                function () {
                  const formDataRemove = new FormData(this.form);
                  let configRemove = Object.assign({}, config);
                  configRemove.body = formDataRemove;
                  configRemove.body.delete('selling_plan', this.dataset.line);
                  configRemove.body.delete('id', this.dataset.line);
                  configRemove.body.append('line', this.dataset.line);
                  configRemove.body.set('quantity', "0");
                  return configRemove;
                }
            }
          };

          return fetch(actions.remove.url, (actions.remove.config.bind(this))())
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                return;
              }
              return fetch(actions.add.url, (actions.add.config.bind(this))())
                .then(response => response.json())
            })
        } else {
          if (this.multiple) {
            let body = JSON.stringify({ 'items': getItemsFromFormData(), ...{ sections }, ...{ sections_url } });
            config = { ...fetchConfig('javascript'), ...{ body } };

          } else if (this.multipleForms) {
            let items = [], item, formData;

            this.querySelectorAll('form[data-available="true"]').forEach(item => {
              formData = new FormData(item);
              item = { id: formData.get('id'), quantity: formData.get('quantity') };
              formData.get('selling_plan') && (item.selling_plan = formData.get('selling_plan'));
              items.push(item)
            });

            let body = JSON.stringify({ items, ...{ sections }, ...{ sections_url } });
            config = { ...fetchConfig('javascript'), ...{ body } };

          } else {
            const priceTagPayload = window.vibranetBuildPriceTagServicePayload?.(this.form, sections, sections_url);
            if (priceTagPayload) {
              config = { ...fetchConfig('javascript'), ...{ body: JSON.stringify(priceTagPayload) } };
            } else {
            formData.append('sections', sections);
            formData.append('sections_url', sections_url);
            config.body = formData;
            }
          }
          const response = await fetch(routes.cart_add_url, config);
          return await response.json();
        }
      };

      getConnected()
        .then((response) => {
          if (response.status) {
            return refreshCartAfterRejectedAdd.call(this, response.description).then((handled) => {
              if (handled) return;
              this.handleErrorMessage(response.description);
              if (this.edit) {
                this.backupFormData.append('sections', sections);
                this.backupFormData.append('sections_url', sections_url);
                config.body = this.backupFormData;
                fetch(routes.cart_add_url, config);
              }
            });
          }


          if (this.cartItems) {
            this.cartItems.renderContents(response);
            this.cartItems.toggleEmptyClass(response);
          } else {
            updateHeaderCartCount();
          }


          this.setParsedState(response);
          this.cartItems?.setCartJs();
          showAddedToCartNotice(response);

          const shippingCalculator = document.querySelector('shipping-calculator') || document.querySelector('shipping-calculator-cart');
          shippingCalculator?.setUpdateStatus('true');


          if (document.body.classList.contains('template-cart')) {
            jq_lumia.fancybox.close();
            scrollToTopHandler();
          } else {
            if (document.querySelector('body').classList.contains('header-cart-dropdown')) {
              new Promise(resolve => {
                statusDrawer.call(this, response, this.edit);
                setTimeout(() => {
                  return resolve(true)
                }, isCartOpened() ? 0 : 1000);
              }).then(() => {
                const getSection = {
                  section: 'frequently-bought-together-view-cart',
                  selector_to: '[data-render="fbt_cart"]',
                  selector_from: '.shopify-section',
                  getUrl() {
                    let url = window.Shopify.routes.root + `products/${response.handle ? response.handle : response.items[0].handle}?section_id=${this.section}`

                    if (document.body.classList.contains('fbt-app')) {
                      url = window.routes.product_recommendations_url + `?section_id=${this.section}` + `&product_id=${response.product_id ? response.product_id : response.items[0].id }&limit=${document.body.dataset.fbtLimit}&intent=complementary`
                    }

                    return url
                  },
                  load() {
                    return fetch(this.getUrl())
                      .then(response => response.text())
                      .then(response => {
                        const html = new DOMParser().parseFromString(response, 'text/html');
                        const element = html.querySelector('.minicart-prd');
                        if (element) {
                          document.querySelector(this.selector_to).innerHTML = html.querySelector(this.selector_from).innerHTML;
                          document.querySelector('mini-cart-popup')?.openChild();
                        } else {
                          document.querySelector('mini-cart-popup')?.closeChild();
                        }
                      }).catch(e => console.error(e));
                  }
                };
                getSection.load()
              });
            }
          }

          if (this.productCard) {
            this.productCard.enableHover();

            if (!this.productCard.matches(':hover')) {
              this.productCard.onProductUnHover()
            }
          }
        }).catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading-process');
          this.form.classList.remove('loading-process');
          submitButton.removeAttribute('aria-disabled');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (!document.querySelector('body').classList.contains('header-cart-dropdown')) {
            const textDefault = submitButton.querySelector('span').textContent;
            const hoverElement = submitButton.querySelector('span.btn-hover-txt');
            const svgDefault = hoverElement?.innerHTML;
            const textElement = submitButton.querySelector('span');

            textElement.textContent = window.variantStrings.added_to_cart
            hoverElement && (hoverElement.textContent = window.variantStrings.added_to_cart)

            setTimeout(()=>{
              textElement.textContent = textDefault
              hoverElement && (hoverElement.innerHTML = svgDefault)
            }, 1000);
          }
        });

      function updateHeaderCartCount() {
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const visibleItemCount = cart.items.reduce((total, item) => {
              return item.properties?._vb_price_tag_fee === 'true' ? total : total + item.quantity;
            }, 0);
            document.querySelectorAll('.header-cart-count').forEach((counter) => {
              let badge = counter.querySelector('.minicart-qty');

              if (visibleItemCount > 0 && !badge) {
                badge = document.createElement('span');
                badge.className = 'minicart-qty';
                counter.appendChild(badge);
              }

              if (badge) {
                badge.textContent = visibleItemCount;
                badge.toggleAttribute('hidden', visibleItemCount < 1);
              }
            });
            return cart;
          })
          .catch((e) => {
            console.error(e);
          });
      }

      function getVisibleCartQuantity() {
        if (this.cartItems) {
          return Array.from(this.cartItems.querySelectorAll('[name="updates[]"]'))
            .reduce((total, input) => total + Number(input.value || 0), 0);
        }

        const badge = document.querySelector('.header-cart-count .minicart-qty');
        return Number(badge?.textContent || 0);
      }

      function fetchRenderedCartSections() {
        if (!sections.length) return Promise.resolve({});
        const cartUrl = window.routes?.cart_url || `${window.Shopify.routes.root}cart`;
        return fetch(`${cartUrl}?sections=${sections.join(',')}`)
          .then((response) => response.json());
      }

      function refreshCartAfterRejectedAdd(message) {
        return updateHeaderCartCount()
          .then((cart) => {
            if (!cart || !cart.items) return false;

            const visibleItemCount = cart.items.reduce((total, item) => {
              return item.properties?._vb_price_tag_fee === 'true' ? total : total + item.quantity;
            }, 0);

            if (visibleItemCount <= visibleCartQuantityOld) return false;

            return fetchRenderedCartSections()
              .then((renderedSections) => {
                const parsedState = { ...cart, sections: renderedSections };
                if (this.cartItems && Object.keys(renderedSections).length) {
                  this.cartItems.renderContentsAndDependencies(parsedState);
                }
                this.setParsedState(parsedState);
                this.cartItems?.setCartJs();
                showAddedToCartNotice({
                  product_title: message || 'Quantita aggiornata alla disponibilita'
                });

                if (document.querySelector('body').classList.contains('header-cart-dropdown')) {
                  document.querySelector('mini-cart-popup')?.open();
                }

                return true;
              });
          })
          .catch((error) => {
            console.error(error);
            return false;
          });
      }

      function showAddedToCartNotice(response) {
        const existingToast = document.querySelector('[data-vb-cart-toast]');
        existingToast?.remove();

        const title = response?.product_title || response?.title || response?.items?.[0]?.product_title || 'Prodotto';
        const toast = document.createElement('div');
        toast.className = 'vb-cart-toast';
        toast.setAttribute('data-vb-cart-toast', '');
        toast.setAttribute('role', 'status');

        const icon = document.createElement('div');
        icon.className = 'vb-cart-toast__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';

        const body = document.createElement('div');
        body.className = 'vb-cart-toast__body';
        const strong = document.createElement('strong');
        strong.textContent = 'Aggiunto al carrello';
        const productTitle = document.createElement('span');
        productTitle.textContent = title;
        body.append(strong, productTitle);

        const link = document.createElement('a');
        link.className = 'vb-cart-toast__link';
        link.href = window.routes?.cart_url || '/cart';
        link.textContent = 'Vai al carrello';

        toast.append(icon, body, link);

        document.body.appendChild(toast);
        window.requestAnimationFrame(() => toast.classList.add('is-visible'));

        window.setTimeout(() => {
          toast.classList.remove('is-visible');
          window.setTimeout(() => toast.remove(), 220);
        }, 3200);
      }

      function isCartOpened() {
        return document.querySelector('.dropdn-modal-minicart')?.classList.contains('is-opened') || false;
      }

      function statusDrawer(response, edit = false) {
        const cartItemsElement = document.querySelector('cart-items');
        if (!cartItemsElement) return true;
        let cartItemsCountNew = cartItemsElement.querySelectorAll('.minicart-prd').length;
        if (edit) {
          this.cartItems.setStatus('edit', null, 1, !isCartOpened());
        } else {
          if ((cartItemsCountNew > cartItemsCountOld)) {
            const args = response.items ? ['new', null, response.items.length, !isCartOpened()] : '';
            this.cartItems.setStatus(...args);
          } else {
            const variant = response;
            fetch(window.Shopify.routes.root + `cart.js`)
              .then((response) => response.json())
              .then((response) => {
                if (response.items) {
                  let cartLine;
                  function checkPlans(variant, item) {
                    if ('selling_plan_allocation' in variant && 'selling_plan_allocation' in item) {
                      return Object.entries(variant.selling_plan_allocation).toString() === Object.entries(item.selling_plan_allocation).toString();
                    } else if (!('selling_plan_allocation' in variant || 'selling_plan_allocation' in item)) {
                      return true
                    }
                    return false;
                  }

                  cartLine = response.items.findIndex(item => {
                    return item.id === variant.variant_id &&
                      Object.entries(variant.properties).toString() === Object.entries(item.properties).toString() &&
                      checkPlans(variant, item)
                  }
                  ) + 1;
                  this.cartItems.setStatus('updated', cartLine);
                }
              }).catch((e) => {
                console.error(e);
              });
          }
        }
        return true;
      }

      function getItemsFromFormData() {
        const formDataArray = Array.from(formData);
        let items = [];
        let i = 1;
        for (let pair of formData.entries()) {
          pair[0] === 'id' && formDataArray.some(item => item[0] === pair[1]) && (
            formDataArray[i][0] === 'selling_plan' && items.push({
              "id": parseInt(pair[1]),
              "selling_plan": parseInt(formDataArray[i][1]),
              "quantity": parseInt(formDataArray[i + 1][1])
            }) || items.push({
              "id": parseInt(pair[1]),
              "quantity": parseInt(formDataArray[i][1])
            })
          );
          i++;
        }
        return items;
      }
    }

    setParsedState(response) {
      localStorage.setItem('parsedState', JSON.stringify(response));
    }

    handleErrorMessage(errorMessage = false) {
      if (this.multipleForms) {
        this.errorMessageWrapper = this.querySelector('[data-product-form-error-message-wrapper]');
      } else {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.closest('[data-section-render]').querySelector('.product-form__error-message-wrapper');
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.multipleForms && this.querySelectorAll('.product-form__error-message-wrapper').forEach(item => item.toggleAttribute('hidden', true));
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        if (this.productCard) {
          new Promise(resolve => {
            if (!this.productCard.matches(':hover')) {
              this.productCard.onProductHover();
            }
            resolve();
          }).then(() => {
            this.errorMessage.textContent = errorMessage;
            this.productCard.enableHover();
          })
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}

if (!window.vibranetPriceTagServiceBound) {
  window.vibranetPriceTagServiceBound = true;

  const getPriceTagServiceParts = (service) => ({
    enabled: service.querySelector('[data-vb-price-tag-enabled]'),
    panel: service.querySelector('[data-vb-price-tag-panel]'),
    value: service.querySelector('[data-vb-price-tag-value]'),
    currency: service.querySelector('[data-vb-price-tag-currency]'),
    label: service.querySelector('[data-vb-price-tag-label]:checked'),
    error: service.querySelector('[data-vb-price-tag-error]')
  });

  const updatePriceTagServiceState = (service) => {
    const parts = getPriceTagServiceParts(service);
    const enabled = Boolean(parts.enabled?.checked);
    service.classList.toggle('is-active', enabled);
    parts.enabled?.setAttribute('aria-expanded', enabled ? 'true' : 'false');
    if (parts.panel) parts.panel.hidden = !enabled;
    if (!enabled && parts.error) {
      parts.error.textContent = '';
      parts.error.hidden = true;
    }
  };

  const showPriceTagServiceError = (service, message = '') => {
    const error = service.querySelector('[data-vb-price-tag-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const priceTagVariantCache = {};

  const formatPriceTagMoney = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';

    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || navigator.language || 'it-IT';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(value / 100);
    } catch (error) {
      return `${(value / 100).toFixed(2)} ${currency}`;
    }
  };

  const getPriceTagVariantImage = (variant) => {
    const image = variant?.featured_image || variant?.image || variant?.product_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  };

  const hydratePriceTagOption = async (input) => {
    const variantId = input?.dataset.vbPriceTagVariant;
    if (!variantId) return;

    try {
      priceTagVariantCache[variantId] = priceTagVariantCache[variantId] || fetch(`/variants/${variantId}.js`).then((response) => response.ok ? response.json() : null);
      const variant = await priceTagVariantCache[variantId];
      if (!variant) return;

      const option = input.closest('label');
      const price = option?.querySelector('[data-vb-price-tag-unit-price]');
      const media = option?.querySelector('[data-vb-price-tag-media]');
      const imageUrl = getPriceTagVariantImage(variant);

      if (price && variant.price) price.textContent = `Prezzo etichetta ${formatPriceTagMoney(variant.price)}`;
      if (media && imageUrl && !media.dataset.loaded) {
        media.dataset.loaded = 'true';
        media.innerHTML = `
          <button class="vb-price-tag-service__image-button" type="button" data-vb-price-tag-image="${imageUrl}" aria-label="Ingrandisci immagine etichetta">
            <img src="${imageUrl}" alt="" loading="lazy">
          </button>
        `;
      }
    } catch (error) {
      console.error('Vibranet price tag variant preview failed', error);
    }
  };

  const hydratePriceTagService = (service) => {
    service.querySelectorAll('[data-vb-price-tag-label]').forEach(hydratePriceTagOption);
  };

  const validatePriceTagService = (service) => {
    const parts = getPriceTagServiceParts(service);
    if (!parts.enabled?.checked) return true;

    if (!parts.value?.value) {
      showPriceTagServiceError(service, 'Inserisci il prezzo da apporre.');
      return false;
    }

    if (!parts.currency?.value) {
      showPriceTagServiceError(service, 'Seleziona la valuta.');
      return false;
    }

    if (!parts.label) {
      showPriceTagServiceError(service, 'Seleziona la tipologia di etichetta.');
      return false;
    }

    showPriceTagServiceError(service);
    return true;
  };

  const getFormProperties = (form) => {
    const properties = {};
    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    }
    return properties;
  };

  window.vibranetBuildPriceTagServicePayload = (form, sections, sectionsUrl) => {
    const service = form?.querySelector('[data-vb-price-tag-service]');
    if (!service) return null;

    updatePriceTagServiceState(service);
    if (!validatePriceTagService(service)) {
      service.scrollIntoView({ behavior: 'smooth', block: 'center' });
      throw new Error('Vibranet price tag service validation failed');
    }

    const parts = getPriceTagServiceParts(service);
    if (!parts.enabled?.checked) return null;

    const formData = new FormData(form);
    const quantity = Math.max(1, Number(formData.get('quantity') || 1));
    const variantId = Number(formData.get('id'));
    const sellingPlan = formData.get('selling_plan');
    const feeVariantId = Number(parts.label.dataset.vbPriceTagVariant);
    const group = `prezzatura-${variantId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const priceText = `${parts.value.value} ${parts.currency.value}`;
    const baseProperties = getFormProperties(form);

    const mainItem = {
      id: variantId,
      quantity,
      properties: {
        ...baseProperties,
        'Servizio prezzatura': 'Sì',
        'Prezzo da apporre': priceText,
        'Valuta': parts.currency.value,
        'Tipologia etichetta': parts.label.value,
        '_vb_price_tag_group': group,
        '_vb_price_tag_fee_variant': String(feeVariantId)
      }
    };

    if (sellingPlan) mainItem.selling_plan = sellingPlan;

    return {
      items: [
        mainItem,
        {
          id: feeVariantId,
          quantity,
          properties: {
            '_vb_price_tag_fee': 'true',
            '_vb_price_tag_group': group,
            '_vb_price_tag_parent_variant': String(variantId),
            '_vb_price_tag_parent_title': form.closest('.vb-product-page')?.querySelector('.prd-block-name')?.textContent?.trim() || ''
          }
        }
      ],
      sections,
      sections_url: sectionsUrl
    };
  };

  document.addEventListener('change', (event) => {
    const service = event.target.closest('[data-vb-price-tag-service]');
    if (service) updatePriceTagServiceState(service);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vb-price-tag-image]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const src = button.dataset.vbPriceTagImage;
    if (src && typeof jq_lumia !== 'undefined' && jq_lumia?.fancybox) {
      jq_lumia.fancybox.open({ src });
    } else if (src) {
      window.open(src, '_blank', 'noopener');
    }
  });

  document.addEventListener('input', (event) => {
    const service = event.target.closest('[data-vb-price-tag-service]');
    if (service) showPriceTagServiceError(service);
  });

  document.addEventListener('submit', (event) => {
    const service = event.target.closest('form')?.querySelector('[data-vb-price-tag-service]');
    if (!service) return;
    updatePriceTagServiceState(service);
    if (!validatePriceTagService(service)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      service.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-vb-price-tag-service]').forEach((service) => {
      hydratePriceTagService(service);
      updatePriceTagServiceState(service);
    });
  });

  document.addEventListener('theme:section:load', () => {
    document.querySelectorAll('[data-vb-price-tag-service]').forEach((service) => {
      hydratePriceTagService(service);
      updatePriceTagServiceState(service);
    });
  });
}
